<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Integrate'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-card>
      <form [formGroup]="form" novalidate action="#">
        <tidy-row>
          <tidy-radio-button
            [label]="'Do you use a property management system (PMS) to manage your properties?'"
            formControlName="type"
            [form]="form.controls.type"
            [items]="typeItems"
            [submitted]="submitted"
            [errorMessage]="'Please select an option.'"
            (optionChange)="onTypeChange()" />
        </tidy-row>
        <tidy-row [ngStyle]="{'display': form.value.type === 'no' ? 'block' : 'none'}" class="extra-top-padding">
          <tidy-radio-button
            [label]="'What is your primary way of renting properties?'"
            formControlName="primaryType"
            [form]="form.controls.primaryType"
            [items]="primaryTypeItems"
            [submitted]="submitted"
            [errorMessage]="'Please select the primary way you rent properties.'" />
        </tidy-row>
      </form>
    </tidy-card>

    <tidy-row class="align-right">
      <tidy-button
        [text]="'Skip and view all integrations'"
        [action]="boundSkipAndViewAllIntegrations"
        [class]="'secondary'" />
      <tidy-button
        [text]="'Next'"
        [action]="boundGoToAddIntegrationPage"
        [class]="'primary'" />
    </tidy-row>
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
